import { IGame } from "@src/types/api";

const getOpponentInfo = (game: IGame | null, teamId?: number) => {
    const isHome = teamId ? game?.home.id === teamId : false;
    const opponent = isHome ? game?.visitor : game?.home;
    const prefix = isHome ? "vs" : "@";

    return {
        opponent: opponent?.name,
        prefix,
        isHome,
    };
};

export default getOpponentInfo;
